/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessReviewTemplate', 'model/BusinessReviewTemplateReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/BusinessReviewTemplate'), require('../model/BusinessReviewTemplateReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewTemplateApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessReviewTemplate, root.ForStractionServiceApi.BusinessReviewTemplateReport);
  }
}(this, function(ApiClient, BusinessReviewTemplate, BusinessReviewTemplateReport) {
  'use strict';

  /**
   * BusinessReviewTemplate service.
   * @module api/BusinessReviewTemplateApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new BusinessReviewTemplateApi. 
   * @alias module:api/BusinessReviewTemplateApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the businessReviewTemplateAddPut operation.
     * @callback module:api/BusinessReviewTemplateApi~businessReviewTemplateAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessReviewTemplate} body 
     * @param {module:api/BusinessReviewTemplateApi~businessReviewTemplateAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.businessReviewTemplateAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewTemplateAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewTemplateAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/BusinessReviewTemplate/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewTemplateGenerateSessionsForUserGet operation.
     * @callback module:api/BusinessReviewTemplateApi~businessReviewTemplateGenerateSessionsForUserGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateSessionsForUser
     * @param {String} _4SAPIAppID 
     * @param {Integer} targetUserID 
     * @param {module:api/BusinessReviewTemplateApi~businessReviewTemplateGenerateSessionsForUserGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessReviewTemplateGenerateSessionsForUserGet = function(_4SAPIAppID, targetUserID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewTemplateGenerateSessionsForUserGet";
      }

      // verify the required parameter 'targetUserID' is set
      if (targetUserID == undefined || targetUserID == null) {
        throw "Missing the required parameter 'targetUserID' when calling businessReviewTemplateGenerateSessionsForUserGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'targetUserID': targetUserID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessReviewTemplate/generateSessionsForUser', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewTemplateLoadAllGet operation.
     * @callback module:api/BusinessReviewTemplateApi~businessReviewTemplateLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BusinessReviewTemplateReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxSessionsCount  (default to 0)
     * @param {module:api/BusinessReviewTemplateApi~businessReviewTemplateLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BusinessReviewTemplateReport>}
     */
    this.businessReviewTemplateLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewTemplateLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxSessionsCount': opts['maxSessionsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [BusinessReviewTemplateReport];

      return this.apiClient.callApi(
        '/BusinessReviewTemplate/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
